export interface AgentManifest {
  key: string;
  label: string;
  category: string;
  order: number;
}

/**
 * An assistant message is a sequence of parts so prose tokens and structured
 * events (tool calls, errors) can render with different chrome. User messages
 * are always a single text part.
 */
export interface MessagePart {
  id: string;
  kind: "error" | "event" | "text";
  text: string;
}

type Role = "assistant" | "user";

export interface AgentMessage {
  id: string;
  parts: MessagePart[];
  role: Role;
}

export interface AgentEventMessage {
  content: string;
  role: Role;
}

// Event `data` prefixes that mark runtime diagnostics — noise for end users.
const DEBUG_EVENT_PREFIXES = [
  "♥",
  "🤔",
  "💭",
  "🔧",
  "✓",
  "[TOKEN]",
  "[diag]",
  "[tick]",
  "[debug]",
] as const;

export function isDebugEvent(data: string): boolean {
  return DEBUG_EVENT_PREFIXES.some((prefix) => data.startsWith(prefix));
}
